// Get Verified Domains
export const GET_VERIFIED_DOMAINS_REQUEST = 'GET_VERIFIED_DOMAINS_REQUEST';
export const GET_VERIFIED_DOMAINS_DONE = 'GET_VERIFIED_DOMAINS_DONE';
export const GET_VERIFIED_DOMAINS_FAILED = 'GET_VERIFIED_DOMAINS_FAILED';

// Operations
export const VERIFIED_DOMAINS_SET_PAGE = 'VERIFIED_DOMAINS_SET_PAGE';